import { Platform, AlertController } from "@ionic/angular";
import { Injectable, EventEmitter, Self } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Storage } from "@ionic/storage-angular";
import { tap, catchError, map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { Global } from "../../global";
import { RouterLink, ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../app.service";
import { FileService } from "../services/file.service";
import { NetworkService, ConnectionStatus } from "../services/network.service";
import { OfflineManagerService } from "../services/offline-manager.service";
import { ServiceInjector } from "../modules/service-injector.module";
import { Observable } from "rxjs";
import { PageHeaderComponent } from "../header/page-header/page-header.component";
import { NotificationService } from "../modals/modal/components/notifications/notifications.service";

const TOKEN_KEY = "JFRTQGQqJl5taW40Njgw";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  private apiUrl = "";
  //self is needed because below if you say this.onmessage.. it changes this to _this in the console
  self = this;
  constructor(
    private http: HttpClient,
    private helper: JwtHelperService,
    private storage: Storage,
    private plt: Platform,
    private alertController: AlertController,
    public globals: Global,
    private appservice: AppService,
    private router: Router,
    private networkService: NetworkService,
    private offlineManager: OfflineManagerService,
    private fileService: FileService,
    private notificationService: NotificationService // private appPageHeader: PageHeaderComponent, // private notificationService: NotificationService
  ) {
    this.plt.ready().then(() => {
      this.checkToken();
    });
  }

  url = this.globals.XRSBackendURL;
  user = null;
  xrsUser = null;
  authenticationState: EventEmitter<boolean> = new EventEmitter();
  authenticated: boolean = false;
  offlineAuthenticated: boolean = false;
  returnUrl: string;
  procedureList: any;
  procedureReferancePage: string;

  updateUserPassword(updatedUser: any): Observable<any> {
    const url = `${this.apiUrl}/updateUserPassword`;
    return this.http.post(url, updatedUser);
  }

  checkToken() {
    this.storage.get(TOKEN_KEY).then((token) => {
      if (token) {
        let decoded = this.helper.decodeToken(token);
        let isExpired = this.helper.isTokenExpired(token);
        if (!isExpired) {
          this.user = decoded;
          var userObjDecoded = JSON.parse(decoded.User);
          userObjDecoded.UserToken = token;

          this.globals.XRSUser = userObjDecoded;
          if (this.globals.XRSUser.XRSUserTypeCode == "VA") {
            this.procedureReferancePage = "Contractor Login";
          } else {
            this.procedureReferancePage = "People Login";
          }
          let formData: FormData = new FormData();
          formData.append("GUID", this.globals.XRSUser.GUID);
          formData.append("User_Token", this.globals.XRSUser.UserToken);
          formData.append("Referance_Page", this.procedureReferancePage);
          formData.append("Project_GUID", null);

          this.appservice
            .GetProceduresByReferencePage(formData)
            .subscribe(async (res) => {
              try {
                this.procedureList = JSON.parse(res.toString());
                if (
                  this.procedureList != undefined &&
                  this.procedureList.length > 0
                ) {
                  this.storage.remove(TOKEN_KEY);
                } else {
                  this.authenticated = true;
                  this.authenticationState.emit(true);
                }
              } catch (e) { }
            });
        } else {
          this.storage.remove(TOKEN_KEY);
        }
      } else {
        this.authenticated = false;
        this.authenticationState.emit(false);
      }
    });
  }

  register(credentials) {
    return this.http.post(`${this.url}register`, credentials).pipe(
      catchError((e) => {
        this.showAlert(e.error.msg);
        throw new Error(e);
      })
    );
  }

  login(
    WebService_Name: any,
    Reporting_Service_Name: any,
    Unity_Service_Name: any,
    credentials: any,
    XRS_Description_For_Schema: any
  ) {
    // tslint:disable-next-line:no-debugger
    return this.http.post(WebService_Name + "ClientLogin", credentials).pipe(
      tap((res) => {
        try {
          this.authenticated = true;
          this.authenticationState.emit(true);
          const userObj = JSON.parse(res.toString());
          sessionStorage.setItem("baseUrlServices", WebService_Name);
          sessionStorage.setItem("reportServiceRoot", Reporting_Service_Name);
          sessionStorage.setItem("xrsunity", Unity_Service_Name);
          sessionStorage.setItem("UploadURL", this.globals.XRSBackendURL);
          sessionStorage.setItem("WCFURL", this.globals.XRSBaseURLWCFServices);
          this.storage.set(TOKEN_KEY, userObj.UserToken);
          this.storage.set("xrsUser", userObj);
          this.globals.XRSUser = userObj;
          this.user = this.helper.decodeToken(userObj.UserToken);
          this.authenticated = true;
          this.authenticationState.next(true);

          this.notificationService.notificationList();
          this.notificationService.incompleteLessonList();

          this.notificationService.badgeState$.subscribe((state) => {
            this.notificationService.showBadge = state;
          });

          //redirect to link in url | Can be specified in login.page.ts like below
          // if(this.returnUrl)
          // {
          //   this.router.navigateByUrl(this.returnUrl);
          // }
          // this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
          //   if (status === ConnectionStatus.Online) {
          //     console.log('status in app.component', status);
          //     this.offlineManager.checkForEvents().subscribe();
          //     //this.fileService.deleteFolder('STSContent');
          //     this.fileService.downloadUserLessonsContent(this.globals.XRSUser.GUID);
          //   }
          // });
        } catch (e) {
          console.log(e);
        }
      }),
      catchError((e) => {
        throw new Error(e);
      })
    );
  }
  logout() {
    this.storage.remove(TOKEN_KEY).then(() => {
      this.globals.enable_menu("LeftMenu", false);
      this.globals.enable_menu("RightMenu", false);
      this.storage.remove("xrsUser");
      this.authenticated = false;
      this.authenticationState.next(false);
    });
  }

  getSpecialData() {
    return this.http.get(`${this.url}special`).pipe(
      catchError((e) => {
        let status = e.status;
        if (status === 401) {
          this.showAlert("You are not authorized for this!");
          this.logout();
        }
        throw new Error(e);
      })
    );
  }

  isAuthenticated() {
    //Single frontend
    // if (!this.authenticated) {
    //   this.router.navigate(["login"]);
    // }
    // return this.authenticated;

    //Multi frontend : this is to properly check that the user is authenticated. We set the local storage before we redirect to client sub-path
    var authenticationState = "false";
    var encryptedAuthenticationObject = localStorage.getItem("IsAuthenticated");
    if (encryptedAuthenticationObject != null) {
      var decryptedAuthenticationObject = this.appservice.decrypt(
        encryptedAuthenticationObject,
        "79653FCD-0BA3-4790-9DA9-8782EADB1EA1"
      );
      var authenticationObject = JSON.parse(decryptedAuthenticationObject);
      authenticationState = authenticationObject.activated;
      //disabled for now
      //this.globals.loadGlobalsFromSessionStorage();
    }
    if (this.authenticated || authenticationState.includes("true")) {
      return true;
    } else {
      this.router.navigate(["login"]);
      return false;
    }
  }

  showAlert(msg) {
    let alert = this.alertController.create({
      message: msg,
      header: "Error",
      buttons: ["OK"],
    });
    alert.then((alert) => alert.present());
  }
}
